// Discovery handshake: a consumer dispatches ThemeWhereAreYou; the nearest
// theme component responds with ThemeHereIAm, detail.theme pointing at itself.
export type ThemeWhereAreYouEvent = CustomEvent<void>
export const ThemeWhereAreYou = 'theme-where-are-you'

export type ThemeHereIAmEvent = CustomEvent<{
	theme: HTMLElement
}>
export const ThemeHereIAm = 'theme-here-i-am'
